/** @jsx jsx */
import { css, jsx } from "@emotion/core";
import styled from "@emotion/styled";
import { connect } from "react-redux";
import BlogPreviews from "./BlogPreviews";
import WelcomeMessage from "./WelcomeMessage";

function Home({ blogs }) {
  return (
    <Container>
      <WelcomeMessage />
      <BlogPreviews blogData={blogs} header="Popular This Month" />
    </Container>
  );
}

// all it needs is the current page
const select = ({ route, blogs }) => ({
  currentPage: route.currentPage,
  blogs: blogs.filter(item => item.sys.contentType.sys.id === 'blogPost')
});

export default connect(select)(Home);

const Container = styled.div`
  padding: 2em;
  min-height: 100vh;
  color: white;
  box-sizing: border-box;
`;

const BigStylishText = styled.h1`
  font-size: 80px;
  font-weight: normal;
  color: var(--primary);
`;
